@if (router.url === '/health') {
  <router-outlet></router-outlet>
}
@if (router.url !== '/health') {
  <app-header class="aker-floating-header" [akerTitle]="title" [titleClickUrl]="titleClickUrl">
    <app-context-launcher akerTool></app-context-launcher>
  </app-header>
  @if (isAdminRoute) {
    <div class="page-container admin-page">
      <router-outlet></router-outlet>
    </div>
  } @else {
    <div class="page-container">
      <app-side-navigation class="aker-dark-theme" [isOnline]="!offlineMode"></app-side-navigation>
      <div class="main-container">
        <!-- Context toolbar intentionally hidden during UI refactor. Kept here (commented) so it can be restored easily.
        <app-context-toolbar [isOnline]="!offlineMode" [isAdmin]="isAdmin"></app-context-toolbar>
        -->
        <main class="page-content">
          <router-outlet></router-outlet>
        </main>
        @if (offlineMode) {
          <footer>
            <app-offline-toolbar></app-offline-toolbar>
          </footer>
        }
      </div>
    </div>
  }
}

<app-notification-container></app-notification-container>
<app-global-notification-banner></app-global-notification-banner>

<!-- Application-level calendar consent dialog – shown once for users with no consent recorded -->
<app-calendar-consent-dialog
  [visible]="showConsentDialog"
  (consentDecision)="onConsentDecision($event)"
></app-calendar-consent-dialog>

